module.exports = __webpack_public_path__ + "img/icon-print.727b8b46.svg";